import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ViajesService } from 'src/app/_services/viajes.service';
import * as fileSaver from 'file-saver';
import { FileService } from 'src/app/_services/file.service';
import { Router } from '@angular/router';
import { ToursService } from 'src/app/_services/tours.service';

@Component({
  selector: 'app-modal-reserva-confirmada',
  templateUrl: './modal-reserva-confirmada.component.html',
  styleUrls: ['./modal-reserva-confirmada.component.css']
})
export class ModalReservaConfirmadaComponent implements OnInit {

  @Input() id: string;
  data: any;

  constructor(
    private modalService: NgbModal,
    private viajeService: ViajesService, 
    private auxService: AuxiliarService,
    public activeModal: NgbActiveModal,
    private filesService:FileService,
    private router: Router,
    private tourService: ToursService,
  ) { }

  ngOnInit(): void {
    this.obtenerDatos();
    //this.detallesReservacion();
  }

  obtenerDatos(){
    this.viajeService.getCodeReservacion(this.id).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.tourService.datosReservacion(this.id).subscribe(data => {
          if(data instanceof HttpResponse){
            if(data.body !== null && data.body !== undefined && data.body !== ''){
              this.data = data.body;               
            }
          }
        });
      }
    });
  }

  descargarPlanilla() {
    this.filesService.descargarComprobante(this.id).subscribe(response => {
			let blob:any = new Blob([response], { type: 'application/pdf; charset=utf-8' });
			const url = window.URL.createObjectURL(blob);
      var doc = new String( "Comprobante Reservacion "  + "Código "); 
      var nombreDoc = doc.concat( this.data.codigo.toString());
			fileSaver.saveAs(blob, nombreDoc);
		}), error => console.log('Error downloading the file'),
                 () => console.info('File downloaded successfully');
  }

  detallesReservacion(){
    this.tourService.datosReservacion(this.id).subscribe(data => {
      if(data instanceof HttpResponse){
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.data = data.body;           
        }
      }
    });
  }

  closeModal(){
    this.activeModal.dismiss('Cross click');
  }

  goHome(){
    //[routerLink]="['/','tours', 'dashboard']"
    this.closeModal();
    this.router.navigate(['/tours/dashboard']);
  }

  

}
